import { SyntheticEvent } from 'react';
import { useTranslation } from 'react-i18next';

import { DocumentFilters, FormField } from 'core/components';
import { FormLabel } from 'core/elements';
import { InputType, MimeType } from 'core/enums';
import { QuoteEntityType, QuoteType } from 'quotes/enums';

import { QuoteFileSource } from './enums';
import { IQuoteDocumentFilters } from './types';
import { getQuoteFileSourceLabel } from './utils';

interface IProps {
  filters: IQuoteDocumentFilters;
  setFilters: (filters: IQuoteDocumentFilters) => void;
  activeFilterCount: number;
  clearFilters: () => void;
  fileTypeOptions: MimeType[];
  fileSourceOptions: QuoteFileSource[];
  entityType: QuoteEntityType;
  quoteType: QuoteType;
}

export const Filters = ({
  filters,
  setFilters,
  activeFilterCount,
  clearFilters,
  fileTypeOptions,
  fileSourceOptions,
  entityType,
  quoteType,
}: IProps) => {
  const { t } = useTranslation();

  return (
    <DocumentFilters
      filters={filters}
      setFilters={setFilters}
      activeFilterCount={activeFilterCount}
      clearFilters={clearFilters}
      fileTypeOptions={fileTypeOptions}
    >
      <FormLabel>{t('labelShow')}:</FormLabel>

      <FormField
        name="upload"
        type={InputType.CHECKBOX}
        inputProps={{
          value: filters.upload,
          onChange: (event: SyntheticEvent) =>
            setFilters({ ...filters, upload: (event.target as HTMLInputElement).checked }),
          label: t('labelUploaded'),
        }}
        wrapperStyle={{ width: 'auto' }}
      />

      <FormField
        name="download"
        type={InputType.CHECKBOX}
        inputProps={{
          value: filters.download,
          onChange: (event: SyntheticEvent) =>
            setFilters({
              ...filters,
              download: (event.target as HTMLInputElement).checked,
            }),
          label: t('labelDownloaded'),
        }}
        wrapperStyle={{ width: 'auto' }}
      />

      <FormField
        name="sources"
        type={InputType.SELECT}
        inputProps={{
          value: filters.sources || [],
          onChange: (_, value: QuoteFileSource[]) =>
            setFilters({ ...filters, sources: value || [] }),
          placeholder: t('labelAllSources'),
          options: fileSourceOptions.map((source) => ({
            label: getQuoteFileSourceLabel(entityType, quoteType)[source],
            value: source,
          })),
          clearable: true,
          multiple: true,
          wrapperStyle: { width: 200 },
        }}
      />
    </DocumentFilters>
  );
};
